import Swiper from "https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js";

// Initialize Swiper for the product gallery
document.addEventListener('DOMContentLoaded', function () {
  const initProductGallerySwiper = () => {
    let swiperThumbs = new Swiper(".product-gallery__thumbs", {
      threshold: 50,
      direction: "vertical",
      freeMode: false,
      slidesPerView: 4,
      spaceBetween: 16,
      watchOverflow: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      updateOnWindowResize: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: ".product-gallery__thumbs-pagination--next",
        prevEl: ".product-gallery__thumbs-pagination--prev"
      }
    });

    let swiperFeatured = new Swiper(".product-gallery__featured", {
      direction: "horizontal",
      zoom: true,
      slideClass: "swiper-slide",
      updateOnWindowResize: true,
      threshold: 50,
      mousewheel: {
        forceToAxis: true
      },
      thumbs: {
        swiper: swiperThumbs
      },
      pagination: {
        el: ".product-gallery__pagination",
        type: "bullets"
      }
    });

    // Synchronize the main gallery with thumbnails
    swiperFeatured.on("slideChangeTransitionStart", function () {
      swiperThumbs.slideTo(swiperFeatured.activeIndex);
    });
    swiperThumbs.on("transitionStart", function () {
      swiperFeatured.slideTo(swiperThumbs.activeIndex);
    });
  };

  // Initialize the product gallery swiper functionality
  initProductGallerySwiper();
});